// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery-section{background-color:#fafafa;padding-top:40px;padding-bottom:40px}@media (min-width: 1050px){.gallery-section{padding-top:75px;padding-bottom:75px}}.gallery-list{overflow:hidden;margin-right:-12px;margin-left:-12px;margin-bottom:0}.gallery-list li{width:100%;padding:10px 12px}.gallery-list li img{width:100%}@media (min-width: 768px){.gallery-list li{width:33.3333%;float:left}.gallery-list li:first-child{width:66.666%;height:100%}}\n", ""]);
// Exports
module.exports = exports;
